var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account-circle-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60 10C87.614 10 110 32.3858 110 60C110 87.614 87.614 110 60 110C32.3858 110 10 87.614 10 60C10 32.3858 32.3858 10 60 10ZM60.7985 80C50.6215 80 41.4591 84.3435 35.0638 91.278C41.902 96.737 50.57 100 60 100C69.8475 100 78.8635 96.4415 85.833 90.5405C79.478 84.037 70.6095 80 60.7985 80ZM60 20C37.9086 20 20 37.9086 20 60C20 69.053 23.0075 77.4035 28.0779 84.107C36.282 75.4205 47.9072 70 60.7985 70C73.2205 70 84.4665 75.033 92.609 83.171C97.263 76.6335 100 68.6365 100 60C100 37.9086 82.0915 20 60 20ZM60 25C71.0455 25 80 33.9543 80 45C80 56.0455 71.0455 65 60 65C48.9543 65 40 56.0455 40 45C40 33.9543 48.9543 25 60 25ZM60 35C54.477 35 50 39.4772 50 45C50 50.523 54.477 55 60 55C65.523 55 70 50.523 70 45C70 39.4772 65.523 35 60 35Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleIcon);
export default __webpack_public_path__ + "static/media/Account_circle_icon.4c1857bf191bf0162bdb3bd8b7aab7c4.svg";
export { ForwardRef as ReactComponent };